import { render, staticRenderFns } from "./CustomTooltip.vue?vue&type=template&id=b56ae538&scoped=true&"
import script from "./CustomTooltip.vue?vue&type=script&lang=js&"
export * from "./CustomTooltip.vue?vue&type=script&lang=js&"
import style0 from "./CustomTooltip.vue?vue&type=style&index=0&id=b56ae538&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56ae538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b56ae538')) {
      api.createRecord('b56ae538', component.options)
    } else {
      api.reload('b56ae538', component.options)
    }
    module.hot.accept("./CustomTooltip.vue?vue&type=template&id=b56ae538&scoped=true&", function () {
      api.rerender('b56ae538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessCharges/components/CustomTooltip.vue"
export default component.exports